import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useMutation } from "@apollo/client";
import { enqueueSnackbar } from "notistack";
import ScreenLoader from "src/components/hoc/screenLoader";
import INSTAGRAM_LOGIN from "src/graphql/mutation/auth/instagramlogin";
import { getStoredUtmParams } from "src/utils/utmTracker";

const InstagramCallback = () => {
  const navigate = useNavigate();
  // Guard against React 18 StrictMode double-invoking useEffect in development.
  // Instagram auth codes are single-use — a second call immediately fails with
  // "This authorization code has been used".
  const hasFired = useRef(false);

  const [instagramLogin] = useMutation(INSTAGRAM_LOGIN);

  useEffect(() => {
    if (hasFired.current) return;
    hasFired.current = true;

    const params = new URLSearchParams(window.location.search);
    const code = params.get("code");
    if (!code) {
      navigate("/login");
      return;
    }

    const utmParams = getStoredUtmParams();
    instagramLogin({ variables: { code, ...utmParams } })
      .then((res) => {
        if (res.data?.instagramLogin?.success) {
          const parsedData = JSON.parse(res.data?.instagramLogin?.result);
          const { message, isCreated } = parsedData;

          if (isCreated) enqueueSnackbar(message, { variant: "success" });

          navigate("/"); // redirect after successful login
        } else {
          let errorMsg = res.data?.instagramLogin?.error || "Login failed";
          console.error("Instagram login failed:", errorMsg);

          // If the error message is a stringified JSON (fallback parsing)
          try {
            const parsed = JSON.parse(errorMsg);
            if (parsed.error?.message) errorMsg = parsed.error.message;
            else if (parsed.message) errorMsg = parsed.message;
          } catch (e) {
            // Not a JSON string, use as is
          }

          enqueueSnackbar(errorMsg, { variant: "error" });
          navigate("/login");
        }
      })
      .catch((err) => {
        console.error("Instagram login error:", err);
        enqueueSnackbar(err.message || "An unexpected error occurred", {
          variant: "error",
        });
        navigate("/login");
      });
  }, []);

  return <ScreenLoader />;
};

export default InstagramCallback;
